import React, { useState } from "react";
import { useGetkycurlMutation } from "../../app/features/apiSlice";
import { Button, Card, Col, Spinner, Form } from "react-bootstrap";
import { formatNumberToLocal, toastError } from "../../helpers";
import { useParams } from "react-router";
import { useTranslation } from "react-i18next";

const KycCard = ({ kycStatusKey }) => {
  const { lang } = useParams();
  const [redirectUrl, setRedirectUrl] = useState("");
  const { t } = useTranslation();
  const [getkycurl, { isLoading }] = useGetkycurlMutation();
  const [userType, setUserType] = useState(
    kycStatusKey?.userStatus?.entity_type || "person"
  );

  const handleRadioChange = (e) => {
    setUserType(e.target.value);
  };

  const generateKYCUrl = async () => {
    try {
      const data = {
        userType: userType,
        language: lang,
      };
      const response = await getkycurl(data);
      if (response.error) {
        toastError(response.error, response?.error?.data?.errorData?.error);
      } else {
        const url = response?.data?.redirectUrl;
        setRedirectUrl(url);
        if (url) window.open(url, "_blank");
      }
    } catch (err) {
      console.error({ err });
      toastError(err);
    }
  };

  return (
    <Col className="mb-3" md={12}>
      <Card bg="gold" className="h-100">
        <Card.Body>
          {(() => {
            if (kycStatusKey?.userStatus?.kyc_status === null) {
              return (
                <>
                  <p className="mb-0 text-light">{t("complete_kyc")}</p>
                  <Form className="kyc-entity">
                    <div className="my-3">
                      <Form.Check
                        type="radio"
                        label={t("person")}
                        value="person"
                        checked={userType === "person"}
                        onChange={handleRadioChange}
                      />
                      <Form.Check
                        type="radio"
                        label={t("company")}
                        value="company"
                        checked={userType === "company"}
                        onChange={handleRadioChange}
                      />
                    </div>
                  </Form>
                  <Button
                    variant="dark"
                    onClick={generateKYCUrl}
                    disabled={isLoading}
                    size="sm"
                  >
                    KYC
                    {isLoading && (
                      <Spinner size="sm" className="ms-2" animation="grow" />
                    )}
                  </Button>
                  <br />
                  {redirectUrl && (
                    <>
                      <small className="mt-2">
                        {t("redirect_text")}
                        <a
                          href={redirectUrl}
                          target="_blank"
                          rel="noreferrer"
                          className="text-light"
                        >
                          {" "}
                          {t("click_here")}
                        </a>
                      </small>
                    </>
                  )}
                </>
              );
            } 
            // else if (
            //   ["REJECTED", "EXPIRED"].includes(
            //     kycStatusKey?.userStatus?.kyc_status
            //   )
            // ) {
            //   return <p className="mb-0 text-light">{t("expired")}</p>;
            // } 
            else {
              return (
                <>
                  <p className="mb-0 text-light">
                    <b className="text-light">{t("KYCStatus")}:</b>{" "}
                    {t(`${kycStatusKey?.userStatus?.kyc_status}`)}
                  </p>
                  <p className="mb-0 text-light">
                    <b className="text-light">{t("entity")}:</b>{" "}
                    {t(`${kycStatusKey?.userStatus?.entity_type}`)}
                  </p>
                  <p className="mb-0 text-light">
                    <b className="text-light">{t("level")}:</b>{" "}
                    {t(`${kycStatusKey?.userStatus?.level}`)}
                  </p>
                  <p className="mb-0 text-light">
                    <b className="text-light">{t("limit")}:</b> CHF{" "}
                    {formatNumberToLocal(kycStatusKey?.kycRange?.min_range)}{" "}
                    {t("to")} CHF{" "}
                    {formatNumberToLocal(kycStatusKey?.kycRange?.max_range)}{" "}
                  </p>
                  {kycStatusKey?.userStatus?.kyc_status === "OPENED" && (
                    <>
                      <p className="mb-0 text-light mt-3">
                        {t("update_request")}
                      </p>
                      <Button
                        variant="dark"
                        onClick={generateKYCUrl}
                        disabled={isLoading}
                        size="sm"
                      >
                        {t("update")} KYC
                      </Button>
                      {redirectUrl && (
                        <>
                          <small className="mt-2">
                            {t("redirect_text")}
                            <a
                              href={redirectUrl}
                              target="_blank"
                              rel="noreferrer"
                              className="text-light"
                            >
                              {" "}
                              {t("click_here")}
                            </a>
                          </small>
                        </>
                      )}
                    </>
                  )}
                  {kycStatusKey?.userStatus?.kyc_status ===
                    "UPDATE_REQUESTED" && (
                    <>
                      <p className="mb-0 text-light mt-3">
                        {t("update_request")}
                      </p>
                      <Button
                        variant="dark"
                        onClick={generateKYCUrl}
                        disabled={isLoading}
                        size="sm"
                      >
                        {t("update")} KYC
                      </Button>
                      {redirectUrl && (
                        <>
                          <small className="mt-2">
                            {t("redirect_text")}
                            <a
                              href={redirectUrl}
                              target="_blank"
                              rel="noreferrer"
                              className="text-light"
                            >
                              {" "}
                              {t("click_here")}
                            </a>
                          </small>
                        </>
                      )}
                    </>
                  )}
                  {kycStatusKey?.userStatus?.kyc_status === "UNDER_REVIEW" && (
                    <p className="mb-0 text-light mt-3">{t("under_review")}</p>
                  )}
                  {kycStatusKey?.userStatus?.kyc_status === "ACCEPTED" &&
                    kycStatusKey?.userStatus?.level !== "FIFTH" && (
                      <>
                        <Button
                          variant="dark"
                          onClick={generateKYCUrl}
                          disabled={isLoading}
                          size="sm"
                          className="mt-3"
                        >
                          {t("upgrade")} KYC
                        </Button>
                        {redirectUrl && (
                          <>
                            <small className="mt-2">
                              {t("redirect_text")}
                              <a
                                href={redirectUrl}
                                target="_blank"
                                rel="noreferrer"
                                className="text-light"
                              >
                                {" "}
                                {t("click_here")}
                              </a>
                            </small>
                          </>
                        )}
                      </>
                    )}
                </>
              );
            }
          })()}
        </Card.Body>
      </Card>
    </Col>
  );
};

export default KycCard;
